import React from "react";
import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-lawn-ink text-white/80 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-lawn flex items-center justify-center">
              <Leaf className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-display text-xl font-extrabold text-white">LawnLink<span className="text-lawn">Pro</span></span>
          </div>
          <p className="text-sm max-w-xs leading-relaxed">Book trusted lawn care and landscaping services in minutes. The marketplace built for homeowners and serious landscapers.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Customers</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search" className="hover:text-lawn">Find Providers</Link></li>
            <li><Link to="/compare" className="hover:text-lawn">Compare</Link></li>
            <li><Link to="/signup" className="hover:text-lawn">Book Service</Link></li>
            <li><Link to="/referral" className="hover:text-lawn">Refer & Earn</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Providers</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pricing" className="hover:text-lawn">Pricing</Link></li>
            <li><Link to="/signup?role=provider" className="hover:text-lawn">List Your Business</Link></li>
            <li><Link to="/affiliate" className="hover:text-lawn">Affiliate Program</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/blog" className="hover:text-lawn">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-lawn">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-lawn">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-lawn">Privacy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">© 2026 LawnLink Pro. All rights reserved.</div>
    </footer>
  );
}
